import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { DownloadCloud, Edit2, File, Trash2 } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown,
    TooltipApprovalInfo
} from '../../../../../common'

export const ManagementTable = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchManagements } = FetchData
    const { dataManagements, loadingFetchAllManagements } = fetchManagements
    
    const { 
        handleClickFetchSpecificManagement,
        handleClickDeleteManagement,
        handleClickDownloadDoc,
        handleClickShowPdfAdminToCentral
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "gestion_fecha", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "identificador", headerName: "ID", minWidth: 150, filter: true },
        { field: "categoria", headerName: "CATEGORIA", minWidth: 200, filter: true },
        { field: "caja", headerName: "CAJA", minWidth: 350, filter: true },
        // { field: "currency_type", headerName: "TIPO", minWidth: 150, filter: true },
        { field: "nombre_usuario", headerName: "USUARIO", minWidth: 150, filter: true },
        { field: "gestion_tipo", headerName: "GESTION", minWidth: 350, filter: true },
        // { field: "servicio", headerName: "SERVICIO", minWidth: 150, filter: true },
        // { field: "caja_destino", headerName: "DESTINO", minWidth: 150, filter: true },
        // { field: "banco", headerName: "BANCO", minWidth: 150, filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 250,
            maxWidth: 250,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellClass: (params) => {

                if(params.value === 'Rechazado') return 'bg-danger';
                if(params.value === 'Aprobado') return 'bg-success';
                if(
                    [
                        'Pendiente Aprobacion',
                        'Traslado Aprobado',
                        'Revisión de Depósito',
                        'Pago Aprobado',
                        'Esperando Reintegro'
                    ]
                        .includes(params.value)
                ) return 'bg-warning';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data
                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                )
            }
        },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idgestion, idgestiontipo, aprobacion_check, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificManagement(idgestion)}
                        >
                            <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                        {( aprobacion_check === 'Pendiente Aprobacion')&&(
                            <MenuItem
                                onClick={() => handleClickDeleteManagement(idgestion)}
                            >
                                <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                <ListItemText primary="Eliminar" />
                            </MenuItem>
                        )}
                        {/* TRASLADO DE EFECTIVO A CUENTA BANCARIA */}
                        {( idgestiontipo === 2 && aprobacion_check === 'Traslado Aprobado' )&&(
                            <MenuItem
                                onClick={() => handleClickDownloadDoc('traslado-efectivo-banco.pdf')}
                            >
                                <ListItemIcon> <DownloadCloud color="black"/> </ListItemIcon>
                                <ListItemText primary="Autorización de traslado" />
                            </MenuItem>
                        )}
                        {/* TRASLADO DE EFECTIVO A CAJA CENTRAL */}
                        {( idgestiontipo === 1 && aprobacion_check === 'Aprobado' )&&(
                            <MenuItem
                                onClick={() => handleClickShowPdfAdminToCentral(idgestion)}
                            >
                                <ListItemIcon> <File color="black"/> </ListItemIcon>
                                <ListItemText primary="PDF Constancia Traslado" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllManagements) && (<LinearLoading/>)}
            <CustomTableData 
                rowConfig={dataManagements}
                columnConfig={columnConfig}
            />
        </div>
    )
}
